class SlideshowDiversoSection extends HTMLElement {
  constructor() {
    super();
    this.mainSlide = this.querySelector(".swiper-slideshow-diverso-main");
    this.init();
  }

  init() {
    this.initSlideShow();
  }

  pauseVideosOutsideSlide(activeSlide) {
    this.querySelectorAll(".swiper-slide video").forEach((video) => {
      if (!activeSlide || !activeSlide.contains(video)) {
        video.pause();
      }
    });
  }

  playVideosInSlide(activeSlide) {
    if (!activeSlide) return;
    activeSlide.querySelectorAll("video").forEach((video) => {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch((err) => {
          if (err?.name !== "AbortError") console.warn("play failed:", err);
        });
      }
    });
  }

  initSlideShow() {
    let autoplay = this.mainSlide?.dataset.autoplay === "true";
    const loop = this.mainSlide?.dataset.loop === "true";
    const autoPlaySpeed = this.mainSlide?.dataset.autoPlaySpeed
      ? this.mainSlide?.dataset.autoPlaySpeed
      : 3000;
    const effect = this.mainSlide?.dataset.effect
      ? this.mainSlide?.dataset.effect
      : "slide";
    const pauseOnMouseEnter =
      this.mainSlide?.dataset.pauseOnMouseEnter === "true";
    if (autoplay) {
      autoplay = { delay: autoPlaySpeed, pauseOnMouseEnter: pauseOnMouseEnter };
    }
    const _this = this;
    const base = {
      autoplay: autoplay,
      effect: effect,
      loop: loop,
      speed: 400,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: this.querySelector(".swiper-pagination"),
      },
      on: {
        init: function () {
          _this.playVideosInSlide(this.slides[this.activeIndex]);
        },
        slideChangeTransitionStart: function (sw) {
          const currentSlide = this.slides[this.activeIndex];
          currentSlide
            .querySelectorAll("motion-effect")
            .forEach(async (motion) => {
              await motion.initAnimate();
            });
        },
        slideChangeTransitionEnd: function () {
          const currentSlide = this.slides[this.activeIndex];
          _this.pauseVideosOutsideSlide(currentSlide);
          _this.playVideosInSlide(currentSlide);
          currentSlide
            .querySelectorAll("motion-effect")
            .forEach(async (motion) => {
              (motion.classList.remove("animate-delay"),
                await motion.initAnimateEffect());
            });
        },
      },
    };
    return new Swiper(this.mainSlide, base);
  }
}

if (!customElements.get("slideshow-diverso-section")) {
  customElements.define("slideshow-diverso-section", SlideshowDiversoSection);
}
